import { createFileRoute } from '@tanstack/react-router';
import { LotePage } from '@/components/lotes/lote-page';

export const Route = createFileRoute('/_app/custos/atualizacoes/$id')({
  component: LoteRota,
});

function LoteRota() {
  const { id } = Route.useParams();
  return <LotePage key={id} id={id} />;
}
